import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { useTheme } from '@mui/material/styles'

import { useBrand } from 'components/shared/SettingsProvider'

const UI = () => {
  const {
    name,
    marcomUrl,
    contact: { email, phone }
  } = useBrand()

  // calculate current year
  const year = new Date().getFullYear()

  // get header background and text colors
  const theme = useTheme()
  const bgcolor = theme.components.AccountFooter?.Box?.bgcolor || 'black'
  const color = theme.components.AccountFooter?.Box?.color || 'white'

  return (
    <Box
      component='footer'
      align='center'
      p={2}
      mt={2}
      color={color}
      bgcolor={bgcolor}
    >
      <Typography variant='body1' gutterBottom>
        Get in touch with your{' '}
        <Link color={color} href={`${marcomUrl}/contact/`} target='_blank'>
          local director
        </Link>
        {', '} or reach our main office{' '}
        <Link color={color} href={`mailto:${email}?subject=I have a question`}>
          by email
        </Link>{' '}
        or phone: {phone}
      </Typography>
      <Typography variant='body1'>
        Copyright &copy; {year}{' '}
        <Link color={color} target='_blank' href={marcomUrl}>
          {name}
        </Link>
      </Typography>
    </Box>
  )
}

export default UI
